<template>
  <form @submit.prevent="submitRegister" class="compact-form">
    
    <div class="input-group">
      <label for="registerUserName" class="input-label">Nom d'utilisateur* <!-- <span> max 50 caractères</span> --></label>
      <input v-model="username" type="text" class="input-control longer" id="registerUserName" placeholder="Nom d'utilisateur" autocomplete="username" required :maxlength="getMaxLength('username')">
    </div>
    
    <div class="form-row">  
      <div class="input-group">
        <label for="registerSurname" class="input-label">Prénom*</label>
        <input v-model="surname" type="text" class="input-control" id="registerSurname" placeholder="Prénom" required :maxlength="getMaxLength('name')">
      </div>
      
      
      <div class="input-group">
        <label for="registerName" class="input-label">Nom*</label>
        <input v-model="name" type="text" class="input-control" id="registerName" placeholder="Nom" required :maxlength="getMaxLength('name')">
      </div>
    </div>
    
    
    <div class="form-row bigger">
      <div class="input-group">
        <label for="password" class="input-label mdp">Mot de passe*
          <div class="tooltip-container">
            <i class="bi bi-info-circle"></i>
            <div class="tooltip-content">
              Il faut au minimum 8 caractères dont au moins : <br>- une majuscule <br>- une minuscule <br>- un nombre <br>- un caractère spécial de la série '@ $ ! % * ? &amp; _ # + = - ^ ‘ ( ) " « { } . , : ; &lt; &gt; [ ] ` | ~ \ / € £ µ § ¥ ¢'<br> -Les espaces, accents et autres caractères spéciaux ne sont pas acceptés
            </div>
          </div>
        </label>
        <div class="password-wrapper">
          <input v-if="showPassword" v-model="password" type="text" class="input-control" id="password" placeholder="Mot de passe" autocomplete="new-password" required :maxlength="getMaxLength('password')">
          <input v-else v-model="password" type="password" class="input-control" id="password" placeholder="Mot de passe" autocomplete="new-password" required :maxlength="getMaxLength('password')">
          <div @click="toggleShow" class="eye-icon">
            <i class="bi" :class="{ 'bi-eye-slash-fill': showPassword, 'bi-eye-fill': !showPassword }"></i>
          </div>
        </div>
      </div>
      
      
      
      <div class="input-group">
        <label for="confirmPassword" class="input-label">Confirmer le mot de passe*</label>
        <div class="password-wrapper">
          <input v-if="showPassword2" v-model="confirmPassword" type="text" class="input-control" id="confirmPassword" placeholder="Confirmer mot de passe" autocomplete="password" required>
          <input v-else v-model="confirmPassword" type="password" class="input-control" id="confirmPassword" placeholder="Confirmer mot de passe" autocomplete="password" required>
          <div @click="toggleShow2" class="eye-icon">
            <i class="bi" :class="{ 'bi-eye-slash-fill': showPassword2, 'bi-eye-fill': !showPassword2 }"></i>
          </div>
        </div>
      </div>
    </div>
    
    <div class="form-row">
      <div class="input-group">
        <label for="registerEMail" class="input-label">Email*</label>
        <input v-model="email" type="email" class="input-control" id="registerEMail" placeholder="Email" autocomplete="email" required :maxlength="getMaxLength('email')">
      </div>
      
      <div class="input-group">
        <label for="confirmEmail" class="input-label">Confirmer email*</label>
        <input v-model="confirmEmail" type="email" class="input-control" id="confirmEmail" placeholder="Confirmer email" autocomplete="email" required :maxlength="getMaxLength('email')">
      </div>
    </div>
    
    <div class="form-row">
      <div class="input-group">
        <label for="registerPhone" class="input-label">Téléphone</label>
        <input v-model="phone" type="text" class="input-control" id="registerPhone" placeholder="Téléphone" :maxlength="getMaxLength('phone')">
      </div>
      
      <div class="input-group">
        <label for="registerMobile" class="input-label">Mobile</label>
        <input v-model="mobile" type="text" class="input-control" id="registerMobile" placeholder="Mobile" :maxlength="getMaxLength('phone')">
      </div>
    </div>
    
    <div class="form-row">
      <div class="input-group">
        <label for="registerAddress" class="input-label">Adresse</label>
        <input v-model="address" type="text" class="input-control longer" id="registerAddress" placeholder="Adresse" :maxlength="getMaxLength('address')">
      </div>
    </div>
    
    <div class="form-row">
      <div class="input-group">
        <label for="registerCompany" class="input-label">Entreprise*</label>
        <input v-model="company" type="text" class="input-control longer" id="registerCompany" placeholder="Entreprise" required :maxlength="getMaxLength('address')">
      </div>
    </div>
    <div class="form-row">
      <div class="input-group cgu-group">
        <input type="checkbox" id="CGU" required>
        <label class="checkbox-label">En cochant cette case, j'accepte<a target="_blank" :href="cg">les conditions générales d'utilisation de l'outil SméO-META</a></label>
      </div>
    </div>

    <!-- Captcha Section -->
    <div class="form-row">
      <div class="input-group captcha-container">
        <FriendlyCaptcha
            :sitekey="sitekey"
            data-start="auto"
            language="fr"
            @done="onCaptchaDone"
            @error="onCaptchaError"
          />
      </div>
    </div>

    <div class="form-footer">
      <span class="mandatory-notice">* Champs obligatoires</span>
      <button type="submit" class="submit-btn">Enregistrer</button>
    </div>
  </form>
  <div class="register-link">
    <router-link to="/login">Déjà un compte ? Connectez-vous ici</router-link>
  </div>
</template>

<script>
var pwdRules =
    "Il faut au minimum 8 caractères dont au moins : \n" +
    "- une majuscule \n" +
    "- une minuscule \n" +
    "- un nombre \n" +
    "un caractère spécial de la série '@ $ ! % * ? & _ # + = - ^ ‘ ( ) \" « { } . , : ; < > [ ] ` | ~ \\ / € £ µ § ¥ ¢'\n" +
    "-Les espaces, accents et autres caractères spéciaux ne sont pas acceptés";

import FriendlyCaptcha from "@/components/auth/FriendlyCaptcha.vue"
import { mapGetters, mapState } from 'vuex';
import '../../assets/styles/base.css';
import '../../assets/styles/modal.css';
export default {
  components:{
    FriendlyCaptcha
  },
  data() {
    return {
      sitekey:(window.__APP_CONFIG__?.VUE_APP_CAPTCHA || process.env.VUE_APP_CAPTCHA),
      username: "",
      password: "",
      confirmPassword: "",
      name: "",
      surname: "",
      email: "",
      confirmEmail: "",
      address: "",
      company: "",
      phone: "",
      mobile: "",
      showPassword: false,
      showPassword2: false,
      cg: "https://www.lausanne.ch/cg-smeo-meta",
      /* iframe1URL: (window.__APP_CONFIG__?.VUE_APP_IFRAME1_URL || "https://www-test.lausanne.ch/hors-arbo/smeo-1/contentAutogenerated/autogeneratedContainer/col1/00"), */
    };
  },
  
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow2() {
        this.showPassword2 = !this.showPassword2;
    },
    // eslint-disable-next-line no-unused-vars
    onCaptchaDone(token) {
      //console.log("Captcha résolu ! Token :", token);
    },
    onCaptchaError(error) {
      console.error("Erreur Captcha :", error);
      alert("Erreur du captcha, veuillez réessayer.");
    },

    async submitRegister() {
      if (this.password !== this.confirmPassword) {
        alert("Les mots de passe ne correspondent pas !");
        return;
      }

      // eslint-disable-next-line no-useless-escape
      var goodPassWord = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_#+=\-\^‘'()"«{}.,:;<>\[\]`|~\\\/€£µ§¥¢])[a-zA-Z\d@$!%*?&_#+=\-\^‘'()"«{}.,:;<>\[\]`|~\\\/€£µ§¥¢]{8,}$/;
      if(!this.password.match(goodPassWord)){
        alert("Mauvais format de mot de passe !!! \n" + pwdRules);
        return;
      }

      if (this.email !== this.confirmEmail) {
        alert("Les e-mails ne correspondent pas !");
        return;
      }
      const token = document.querySelector('[name="frc-captcha-solution"]')?.value
      try {
        const payload = {
          username: this.username,
          password: this.password,
          name: this.name,
          surname: this.surname,
          email: this.email,
          address: this.address,
          company: this.company,
          phone: this.phone,
          mobile: this.mobile,
          token: token
        }
        await this.$store.dispatch(`auth/register`, payload);

        alert("Enregistrement en cours, visitez votre messagerie pour confirmer votre e-mail avant votre premier login ...");
        //console.log("Register data: ", response);
        this.$router.push('/login');
      } catch (error) {
        //console.log("[error] =>", error);
        //console.log("[typeof error] =>",typeof error);
        //console.log("[error instanceof] =>",error instanceof Error);
        //console.log("[error.message] =>", error.message);
        //console.log("[error.response] =>", error.response);
        //console.log("[error.response?.data] =>", error.response?.data);
        //console.log("[error.error] =>", error.error);
        //console.log("[error.errors] =>", error.errors);
        alert("Erreur: " + error || "Pas de message d'erreur retrouvé");
      }
    }
  },
  computed: {
    ...mapState('referential', ['maxLength']),
    ...mapGetters('referential', ['getMaxLength']),
  },
}
</script>

<style scoped>
.compact-form {
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px var(--shadow-medium);
  margin-bottom: 20px;
  max-width: 900px;
  position: relative;
  margin: 0 auto;
}

.form-row {
  display: flex;
  gap: 16px;
}

.input-group {
  flex: 1;
  min-width: 0;
}

.input-label {
  font-weight: 600;
  font-size: 0.9rem;
  display: block;
  margin-top: 1vh;
}
/* 
.input-label.mdp {
  margin-top: -5px;
} */

.input-control {
  width: 100%;
  padding: 8px 12px;
  font-size: 0.9rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: rgba(245, 245, 245, 0.031);
}
.input-control.longer{
  width: 100%;
}

.password-wrapper {
  position: relative;
  display: flex;
}

/* .password-wrapper .input-control {
  flex: 1;
  padding-right: 40px;
}
 */ 
.eye-icon {
  position: absolute;
  right: 88px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.bi {
  font-size: 1rem;
  padding: 5px 10px;
  margin: 0px -6vw 0px 0px;
/*  Pour avoir les border marqués
  border: 1px solid #ccc;
  border-radius: 0 8% 8% 0; */
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  margin-right: 2.1vw;
}

.mandatory-notice {
  font-size: 0.9rem;
  color: var(--text-color);
  font-style: italic;
}

.tooltip-container {
  display: inline-block;
  position: relative;
  cursor: pointer;
  margin-left: 5px;
  height: 19px;
}


.tooltip-content {
  display: none;
  position: absolute;
  top: -130px;
  left: 40px;
  background-color: #f9f9f9;
  color: var(--text-color);
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  width: 220px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  z-index: 2;
}

.tooltip-container:hover .tooltip-content {
  display: block;
}

a {
    color: var(--primary-color);
    text-decoration: none;
    transition: all 0.3s ease;
    margin: 8px 0 0 0.3rem;
    text-align: center;
  }
  
  a:hover {
    color: var(--primary-color);
    text-decoration: underline;
  }
  span {
    font-size: 0.8rem;
    color: #a9b3bc;
    white-space: nowrap;
    float: right;
  }

  .wrong{
  border: red;
  }

.cgu-group {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 15px 0;
}

.cgu-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.checkbox-label {
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 0;
}

.captcha-container {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
}

.frc-container {
  width: 100% !important;
  max-width: 400px;
}
</style>